module.exports = __webpack_public_path__ + "img/9.a912d4d.png";